import { AfterViewInit, Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreatorTileComponent } from '../creator-tile/creator-tile.component';
import { RosterService } from '../../services/roster.service';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-creator-carousel',
  imports: [CommonModule, CreatorTileComponent],
  templateUrl: './creator-carousel.component.html',
  styleUrl: './creator-carousel.component.css'
})
export class CreatorCarouselComponent implements AfterViewInit, OnInit {
  // roster items consumed by the tile component
  rosters: any[] = [];


  // api details moved to RosterService

  @ViewChild('carousel', { static: false }) carousel!: ElementRef<HTMLDivElement>;

  // how much to scroll on each arrow click (pixels)
  private scrollAmount = 320;

  constructor(private rosterService: RosterService) {}

  ngOnInit(): void {
    this.rosterService.getPublicRosters().pipe(
      catchError((err) => {
        console.error('Failed to load public rosters', err);
        return of([]);
      })
    ).subscribe(list => {
      if (!list || list.length === 0) return;

      this.rosters = list.map(r => ({
          id: r.id,
          name: r.name,
          tiktokHandle: r.tikTokHandle || undefined,
          instagramHandle: r.instagramHandle || undefined,
          youtubeHandle: r.youtubeHandle || undefined,
          tikTokFollowers: r.tikTokFollowers || undefined,
          instagramFollowers: r.instagramFollowers || undefined,
          youtubeFollowers: r.youtubeFollowers || undefined,
          bioTextShort: r.bioTextShort || undefined,
          city: r.city || undefined,
          state: r.state || undefined,
        }));
    });
  }

  ngAfterViewInit(): void {
    // nothing required now, but ViewChild is ready after this
  }

  scrollLeft(): void {
    if (!this.carousel) return;
    this.carousel.nativeElement.scrollBy({ left: -this.scrollAmount, behavior: 'smooth' });
  }

  scrollRight(): void {
    if (!this.carousel) return;
    this.carousel.nativeElement.scrollBy({ left: this.scrollAmount, behavior: 'smooth' });
  }
}
